import { Component } from '@theme/component';

/**
 * Creator Desktop — click a desktop icon to open its "window", click the red
 * dot (or open another window) to close it. Plain show/hide via the `hidden`
 * attribute, event-delegated so it works regardless of how many windows a
 * merchant configures.
 *
 * @extends Component<{}>
 */
class CreatorDesktopComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.#handleClick);
  }

  /**
   * @param {MouseEvent} event
   */
  #handleClick = (event) => {
    const target = /** @type {HTMLElement} */ (event.target);

    const openTrigger = target.closest('[data-open]');
    if (openTrigger instanceof HTMLElement) {
      const id = openTrigger.dataset.open;
      const win = id ? this.querySelector(`#${CSS.escape(id)}`) : null;
      if (win instanceof HTMLElement) {
        // Multiple windows can stay open at once, matching the original
        // desktop-icons metaphor — each icon only ever affects its own window.
        win.hidden = false;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        win.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start', inline: 'center' });
      }
      return;
    }

    const closeTrigger = target.closest('[data-close]');
    if (closeTrigger instanceof HTMLElement) {
      const id = closeTrigger.dataset.close;
      const win = id ? this.querySelector(`#${CSS.escape(id)}`) : null;
      if (win instanceof HTMLElement) win.hidden = true;
    }
  };
}

if (!customElements.get('creator-desktop-component')) {
  customElements.define('creator-desktop-component', CreatorDesktopComponent);
}
